'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { createPath } from 'DesignData/helpers/routingHelper';
import { CODE, NONE } from 'DesignData/enums/settings/Categories';
import * as DesignAssetTypes from 'DesignData/enums/DesignAssetTypes';
import { intersperseFn } from 'DesignData/lib/array';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UIRouterButtonLink from 'ui-addon-react-router-dom/UIRouterButton';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIList from 'UIComponents/list/UIList';
import * as AppActions from 'DesignData/actions/Application';
import { getActiveAssetType } from 'DesignData/selectors/app';

const statusBarI18nKey = key => `DesignEditorsUI.statusBar.header.${key}`;

class StatusBarSettings extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      openSettingsMenu: false
    };

    this.toggleSettingsMenu = () => {
      this.setState({
        openSettingsMenu: !this.state.openSettingsMenu
      });
    };

    this.onOpenChange = ({
      target: {
        value: openSettingsMenu
      }
    }) => {
      this.setState({
        openSettingsMenu
      });
    };

    this.showKeyboardShortcuts = () => {
      this.toggleSettingsMenu();
      this.props.setIsKeyboardShortcutsListingShowing(true);
    };

    this.getSettingsPath = () => {
      const {
        activeAssetType
      } = this.props;
      const assetType = DesignAssetTypes.SETTINGS;
      const assetId = 'settings';
      const editorOptions = {};

      switch (activeAssetType) {
        case DesignAssetTypes.TEMPLATE:
          editorOptions.settingsCategory = CODE;
          break;

        default:
          editorOptions.settingsCategory = NONE;
          break;
      }

      return createPath(assetType, assetId, editorOptions);
    };
  }

  renderShortcutSeparator({
    index
  }) {
    return /*#__PURE__*/_jsx("span", {
      children: "+"
    }, `key-sep-${index}`);
  }

  renderKbd(key, idx) {
    return /*#__PURE__*/_jsx("kbd", {
      children: key
    }, `${key}-${idx}`);
  }

  renderMenuItem({
    iconName,
    title,
    shortcutKeys = [],
    onClick,
    href
  }) {
    let keys = null;

    if (shortcutKeys && shortcutKeys.length) {
      const kbds = shortcutKeys.map(this.renderKbd);
      keys = intersperseFn(kbds, this.renderShortcutSeparator);
    }

    const icon = /*#__PURE__*/_jsx("div", {
      className: "status-bar-popover--icon",
      children: iconName && /*#__PURE__*/_jsx(UIIcon, {
        name: iconName
      })
    });

    const display = /*#__PURE__*/_jsx(UIMediaObject, {
      align: "start",
      itemLeft: icon,
      itemRight: keys,
      children: title
    });

    return href ? /*#__PURE__*/_jsx(UIRouterButtonLink, {
      className: "status-bar-popover--button",
      onClick: onClick,
      to: href,
      use: "transparent",
      children: display
    }) : /*#__PURE__*/_jsx(UIButton, {
      className: "status-bar-popover--button",
      onClick: onClick,
      use: "transparent",
      children: display
    });
  }

  renderMenuItems() {
    return /*#__PURE__*/_jsxs(UIList, {
      children: [this.renderMenuItem({
        iconName: 'settings',
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: statusBarI18nKey('settings.items.settings.title')
        }),
        href: this.getSettingsPath(),
        onClick: this.toggleSettingsMenu
      }), this.renderMenuItem({
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: statusBarI18nKey('settings.items.keyboardShortcuts.title')
        }),
        shortcutKeys: ['Shift', '?'],
        onClick: this.showKeyboardShortcuts
      })]
    });
  }

  render() {
    return /*#__PURE__*/_jsx(UIPopover, {
      className: "status-bar-popover ",
      content: this.renderMenuItems(),
      open: this.state.openSettingsMenu,
      placement: "top left",
      closeOnOutsideClick: true,
      onOpenChange: this.onOpenChange,
      children: /*#__PURE__*/_jsxs(UIButton, {
        className: "status-bar-header-button",
        size: "extra-small",
        use: "transparent",
        onClick: this.toggleSettingsMenu,
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "settings"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: statusBarI18nKey('settings.link')
        })]
      })
    }, "settings-menu-options");
  }

}

StatusBarSettings.propTypes = {
  activeAssetType: PropTypes.oneOf(Object.values(DesignAssetTypes || {})),
  setIsKeyboardShortcutsListingShowing: PropTypes.func
};

const mapStateToProps = state => {
  return {
    activeAssetType: getActiveAssetType(state)
  };
};

const mapDispatchToProps = {
  setIsKeyboardShortcutsListingShowing: AppActions.setIsKeyboardShortcutsListingShowing
};
export default connect(mapStateToProps, mapDispatchToProps)(StatusBarSettings);